import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const getAllCoursesForPerson = (personId) => dispatch => {
  dispatch({ type: "GET_ALL_COURSES_FOR_PERSON_LOADING" });
  api
    .coursesGetAllForPerson(personId)
    .then(resp => {
      dispatch(operationSucceeded(resp.data));
      dispatch({ type: "GET_ALL_COURSES_FOR_PERSON_LOADING_DONE" });
    })
    .catch(e => {
      jsError(e);
      dispatch({ type: "GET_ALL_COURSES_FOR_PERSON_LOADING_DONE" });
      dispatch(operationFail());
      dispatch(buildAlertWithLocalizedMessages(
        "ERROR",
        "GetAllCoursesForPersonErrorAlertTitle",
        "Virhe henkilön muiden koulutusten haussa",
        e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
    });
};

const operationSucceeded = data => ({
  type: "GET_ALL_COURSES_FOR_PERSON_SUCCEEDED",
  payload: { courses: data },
});

const operationFail = () => ({
  type: "GET_ALL_COURSES_FOR_PERSON_FAIL",
});
